import {
  IMG_CUSTOMS_INCHEON_T1,
  IMG_CUSTOMS_INCHEON_T2,
  IMG_CUSTOMS_GIMPO,
  IMG_CUSTOMS_GIMHAE,
  IMG_CUSTOMS_JEJU,
  IMG_CUSTOMS_MAP_GIMPO,
  IMG_CUSTOMS_MAP_GIMHAE,
  IMG_CUSTOMS_MAP_JEJU,
  IMG_CUSTOMS_INCHEON,
  IMG_CUSTOMS_MAP_INCHEON_T1_1,
  IMG_CUSTOMS_MAP_INCHEON_T1_2,
  IMG_CUSTOMS_MAP_INCHEON_T2_1,
  IMG_CUSTOMS_MAP_INCHEON_T2_2,
} from '@repo/assets';

type LocationCustoms = {
  key: 'incheonT1' | 'incheonT2' | 'gimpo' | 'gimhae' | 'jeju';
  name: string;
  engName: string;
};

export const LOCATION_CUSTOMS: LocationCustoms[] = [
  {
    key: 'incheonT1',
    name: '인천공항 T1',
    engName: 'Incheon Airport T1',
  },
  {
    key: 'incheonT2',
    name: '인천공항 T2',
    engName: 'Incheon Airport T2',
  },
  {
    key: 'gimpo',
    name: '김포공항',
    engName: 'Gimpo Airport',
  },
  {
    key: 'gimhae',
    name: '김해공항',
    engName: 'Gimhae Airport',
  },
  {
    key: 'jeju',
    name: '제주공항',
    engName: 'Jeju Airport',
  },
];

export const LOCATION_CUSTOMS_DETAIL = {
  incheonT1: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '3F Check-in Counter B,E,J,L',
        kor: '3층 B, E, J, L 체크인 카운터 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON,
      map: IMG_CUSTOMS_MAP_INCHEON_T1_1,
    },
    {
      type: [{ eng: 'Boarding Area', kor: '면세 구역' }],
      location: {
        eng: '3F Gate 28',
        kor: '3층 중앙 28번 게이트 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON_T1,
      map: IMG_CUSTOMS_MAP_INCHEON_T1_2,
    },
  ],
  incheonT2: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '3F Check-in Counter E,G',
        kor: '3층 E, G 체크인 카운터 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON,
      map: IMG_CUSTOMS_MAP_INCHEON_T2_1,
    },
    {
      type: [{ eng: 'Boarding Area', kor: '면세 구역' }],
      location: {
        eng: '3F Gate 249, 270',
        kor: '3층 249번 게이트, 270번 게이트 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_INCHEON_T2,
      map: IMG_CUSTOMS_MAP_INCHEON_T2_2,
    },
  ],
  gimpo: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '2F - GATE 1',
        kor: '2층 1번 Gate 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_GIMPO,
      map: IMG_CUSTOMS_MAP_GIMPO,
    },
  ],
  gimhae: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '2F - Gate 4 next to refund kiosk',
        kor: '2층 4번 Gate 환급 키오스크 옆',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_GIMHAE,
      map: IMG_CUSTOMS_MAP_GIMHAE,
    },
  ],
  jeju: [
    {
      type: [{ eng: 'Departure Hall', kor: '일반 구역' }],
      location: {
        eng: '3F - Gate 5',
        kor: '3층 5번 Gate 부근',
      },
      time: '',
      tel: '',
      img: IMG_CUSTOMS_JEJU,
      map: IMG_CUSTOMS_MAP_JEJU,
    },
  ],
};
